export const toArray = <T = unknown>(value: T | T[]): T[] =>
  Array.isArray(value) ? value : [value]

export const toUnique = <T = unknown>(array: T[]): T[] =>
  array.filter((value: T, index: number, array: T[]): boolean => array.indexOf(value) === index)
